import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { expensesApi } from 'src/Services/API';

const useFetchAssetMemberBalances = () => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fetch-asset-member-balances', assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');

      return (await expensesApi.expensesControllerFindMemberBalances(assetId)).data;
    },
    enabled: !!assetId,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchAssetMemberBalances;
